module.exports = __webpack_public_path__ + "static/img/state-grid_08.a16bd27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-home/state-grid_08.png
// module id = Ovwh
// module chunks = 1